import { Component, Inject} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {
  GetUserCountByProjectGQL,
} from "../../../../generated/graphql";
import { SnackBarService } from '../../service/snack.bar.service';

export interface DialogData {
  objId: string;
}

@Component({
    selector: 'user-project-dialog',
    templateUrl: 'user-project-dialog.html',
  })

  export class UserProjectDialog{
    title: string = "Project Details";
    roleData: any[];
    projectData: any;
  
    constructor(
      public dialogRef: MatDialogRef<UserProjectDialog>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData,
      private snackBarSvc: SnackBarService,
      private getUserCountByProjectGQL: GetUserCountByProjectGQL,) {
        this.getUserByProject()
    } 

    getUserByProject(){
      this.getUserCountByProjectGQL.fetch({ roleId: this.data.objId}).subscribe((result) =>{
        if(result.errors){
          this.snackBarSvc.showQueryError(result.errors);
        }
        this.roleData = result.data.getUserCountByProject;
      })
    }
  }